import { space } from 'styled-system';
import styled from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import Flex from '../../atoms/Flex';
import Grid from '../../atoms/Grid';
import Text from '../../atoms/Text';
export const Container = styled.section`
  padding: 12px;
  border: solid 1px ${props => getBackgroundColor('whisper')(props)};
  border-radius: 4px;
  ${space}
`;
export const PriceInformation = styled(Flex)`
  justify-content: space-between;
`;
export const Label = styled(Text)`
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  cursor: pointer;
  text-decoration: underline;
`;
export const Description = styled(Text)`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  line-height: ${props => themeGet('lineHeights.input')(props)}em;
`;
export const SidebarHeader = styled(Grid)`
  padding: 12px;
  border-bottom: 1px solid ${props => getBackgroundColor('darker')(props)};
  align-items: center;
  grid-template-columns: auto 1fr;
  grid-gap: 1em;
  margin-bottom: 20px;
`;
export const SidebarTitle = styled(Text)`
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
`;